<template>
  <div>
    <v-select
      label="Template Mailchimp"
      v-if="mailchimpTemplates"
      v-model="selectedValue"
      :items="mailchimpTemplates"
      item-text="name"
      item-value="slug"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  mounted() {
    this.getMailchimpTemplates();
  },
  props: {
    value: {
      type: String
    }
  },
  data: function() {
    return {};
  },
  computed: {
    ...mapGetters("options", ["mailchimpTemplates"]),
    selectedValue: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit("input", newValue);
      }
    }
  },
  methods: {
    ...mapActions("options", ["getMailchimpTemplates"])
  }
};
</script>

<style lang="scss" scoped>
.form__input {
  padding: 0.5rem;
  width: 100%;
  border-radius: 20px;
}
</style>